import React, { Component } from 'react';

class IconChatOpenWindow extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="25"
                fill="none"
                viewBox="0 0 24 25"
            >
                <g fill="#fff" clipPath="url(#clip0_5701_1661)">
                    <path d="M6.38 13.336l4.96 4.982c.084.095.181.177.29.243a1.155 1.155 0 001.534-.266 1.153 1.153 0 00-.093-1.591l-1.823-1.846-1.223-1.234h7.223a1.153 1.153 0 001.154-.622 1.152 1.152 0 000-1.154 1.268 1.268 0 00-1.108-.588h-7.257l3.046-3.021a1.154 1.154 0 000-1.719 1.154 1.154 0 00-.82-.346 1.27 1.27 0 00-.91.38l-5.008 4.983a1.154 1.154 0 00.034 1.8zM23.965 15.804a1.154 1.154 0 00-1.281-.888 1.154 1.154 0 00-1.05 1.154v5.27c0 .53-.22.738-.762.738h-5.169a1.156 1.156 0 00-1.28 1.154 1.153 1.153 0 00.322.83 1.328 1.328 0 00.958.369h5.285a3 3 0 003.023-3.01v-5.294a1.559 1.559 0 00-.046-.323zM8.398.5H2.883A3.012 3.012 0 00-.002 3.452a1.153 1.153 0 001.154 1.223 1.154 1.154 0 001.154-1.153.634.634 0 01.704-.658h5.319a1.154 1.154 0 00.854-.357 1.153 1.153 0 00.334-.842A1.153 1.153 0 008.398.5zM1.19 7.385c.314-.003.616-.126.842-.346.22-.226.343-.527.346-.842a1.153 1.153 0 00-2.308 0 1.222 1.222 0 001.154 1.154l-.034.034zM1.052 10.072h.288A1.154 1.154 0 002.378 8.92a1.153 1.153 0 00-.346-.853 1.154 1.154 0 00-.853-.346A1.154 1.154 0 00.025 8.873a1.153 1.153 0 001.027 1.2z"></path>
                </g>
                <defs>
                    <clipPath id="clip0_5701_1661">
                        <path
                            fill="#fff"
                            d="M0 0H24V24H0z"
                            transform="translate(0 .5)"
                        ></path>
                    </clipPath>
                </defs>
            </svg>
        );
    }
}

export default IconChatOpenWindow;